/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, Input, TemplateRef } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzOptionItemGroupComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-option-item-group",
  templateUrl: "option-item-group.component.html",
})
export class UiOptionItemGroupComponent extends NzOptionItemGroupComponent {
  @Input("optionLabel") nzLabel: string | number | TemplateRef<NzSafeAny> | null = null;
}
